export default "__VITE_ASSET__IXmdi7hv__"